/**
 * @generated SignedSource<<f2fb69eac9b91eb6fe22a256fe8151e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskExecutionComponent_TaskExecution$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionNumberComponent_TaskExecutionNumber" | "TaskExecutionOptionsComponent" | "TaskExecutionTextComponent">;
  readonly " $fragmentType": "TaskExecutionComponent_TaskExecution";
};
export type TaskExecutionComponent_TaskExecution$key = {
  readonly " $data"?: TaskExecutionComponent_TaskExecution$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionComponent_TaskExecution">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskExecutionComponent_TaskExecution",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskExecutionTextComponent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskExecutionNumberComponent_TaskExecutionNumber"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskExecutionOptionsComponent"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "TaskExecution",
  "abstractKey": "__isTaskExecution"
};

(node as any).hash = "067c710eb6c5346173b39656fd2d38fd";

export default node;
